/**
 * Canonical string tokens for shift / task / workday — single source of truth.
 * Import from here in tests or non-store code; the store re-exports the same values.
 */
export const Shift_In = "Shift_In";
export const Shift_Pause = "Shift_Pause";
export const Shift_Resume = "Shift_Resume";
export const Shift_Out = "Shift_Out";
export const Not_Shifted_In = "Not_Shifted_In";

export const Shift_Pause_Unreachable = "Shift_Pause_Unreachable";
export const Shift_Pause_InActive = "Shift_Pause_InActive";

export const Start_Stop = "Start_Stop";
export const Pause_Resume = "Pause_Resume";

export const Task_Start = "Task_Start";
export const Task_Stop = "Task_Stop";
export const Task_Resume = "Task_Resume";
export const Task_Pause = "Task_Pause";

export const Workday_Started = "Workday_Started";
export const Workday_Stopped = "Workday_Stopped";

export const Office_Open = "Office_Open";
export const Office_Close = "Office_Close";
export const Past_Office_Hours = "Past_Office_Hours";
